import { EffectSlot } from '../../core/project/types';
import { EFFECTS } from '../../effects/registry';
import { EffectTarget, useAppStore } from '../../state/store';
import { Knob } from '../widgets/Knob';

function fmt(v: number): string {
  return Math.abs(v) >= 100 ? v.toFixed(0) : Math.abs(v) >= 1 ? v.toFixed(1) : v.toFixed(2);
}

/** One insert effect: enable toggle, name, remove, and param knobs. */
export function EffectRow({ target, slot }: { target: EffectTarget; slot: EffectSlot }) {
  const def = EFFECTS[slot.type];
  const { toggleEffect, removeEffect, updateEffect } = useAppStore.getState();
  if (!def) return null;

  return (
    <div className={`fx-row ${slot.enabled ? '' : 'disabled'}`}>
      <div className="fx-row-head">
        <button
          className="fx-toggle"
          onClick={() => toggleEffect(target, slot.id)}
          title={slot.enabled ? 'Disable' : 'Enable'}
        >
          {slot.enabled ? '●' : '○'}
        </button>
        <span className="fx-name">{def.name}</span>
        <button className="fx-remove" onClick={() => removeEffect(target, slot.id)} title="Remove">
          ×
        </button>
      </div>
      <div className="fx-params">
        {def.params.map((p) => {
          const v = slot.params[p.key] ?? p.default;
          return (
            <label key={p.key} className="fx-param">
              <Knob
                size={20}
                value={v}
                min={p.min}
                max={p.max}
                log={p.min > 0 && p.max / p.min > 4}
                onChange={(nv) => updateEffect(target, slot.id, { [p.key]: nv })}
                title={`${p.label}: ${fmt(v)}${p.unit ?? ''}`}
              />
              <span>{p.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}

/** "+ FX" dropdown that appends an effect to the target's chain. */
export function FxAdd({ target }: { target: EffectTarget }) {
  const { addEffect } = useAppStore.getState();
  return (
    <select
      className="fx-add"
      value=""
      onChange={(e) => {
        if (e.target.value) addEffect(target, e.target.value);
        e.target.value = '';
      }}
      title="Add effect"
    >
      <option value="">+ FX</option>
      {Object.values(EFFECTS).map((def) => (
        <option key={def.type} value={def.type}>
          {def.name}
        </option>
      ))}
    </select>
  );
}